/**
 * DataZoom component entry
 */


    require('./dataZoom/typeDefaulter');

    require('./dataZoom/DataZoomModel');
    require('./dataZoom/DataZoomView');

    require('./dataZoom/SelectZoomModel');
    require('./dataZoom/SelectZoomView');

    require('./dataZoom/dataZoomProcessor');
    require('./dataZoom/dataZoomAction');




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/dataZoomSelect.js
// module id = 992
// module chunks = 0